import React, { useState } from 'react'; 
import Form from './SignupForm'
import '../../CSS/Style.css'

const Signup = () => { 
	return ( 
        <div className='first_sec_ran'>
		<div className='container'> 
        <Form/>
		</div> 
        </div>
	); 
} 
export default Signup;